module.exports = __webpack_public_path__ + "img/y_2008.23536dba.png";